module.exports = __webpack_public_path__ + "static/media/orthostatic-hypotension.20971a2a.png";